import { useQuery } from '@tanstack/react-query';
import { camelizeKeys } from 'humps';

import { ApplicableAddonProps, ApplicableAddonsResponse } from './types';
import { getApplicableAddons } from './services';
import useGetEvent from 'features/common/hooks/useGetEvent';

export const useApplicableAddonsApi = () => {
	const { event } = useGetEvent();
	const eventId = event?.id;
	const ticketTypeIds = (event?.ticketTypes || []).map((tt) => tt.ID);
	const ticketTypeIdsKey = ticketTypeIds.join(',');

	const { data: applicableAddons, refetch } = useQuery({
		queryKey: ['applicableAddons', eventId, ticketTypeIdsKey],
		queryFn: () => getApplicableAddons(eventId as number, ticketTypeIds),
		select: (data) => (camelizeKeys(data) as unknown as ApplicableAddonsResponse).applicableAddons,
		enabled: !!eventId && ticketTypeIds.length > 0,
	});

	return { applicableAddons: applicableAddons as ApplicableAddonProps[] | undefined, refetch };
};
